<template>
    <div class="row">
        <div class="col-12">
            <h1>Support</h1>
            <wizard-state-tracker :stage="stage"/>
        </div>
        <div class="col-12 " :class="{'col-xl-9': !isAppointmentStage}">
            <div :class="{'block': !isAppointmentStage}">
<!--                <router-view/>-->
                <wizard-title-select v-if="isTitleStage" @submit="gotoDetailStage"/>
                <wizard-detail-select v-else-if="isDetailStage" @submit="gotoAppointmentStage" @reset="gotoTitleStage"/>
                <moments-form v-else-if="isAppointmentStage"
                              :title="$t('proposal.header_moments_picker_support')"
                              @submit="submitTicket"
                              @back="gotoDetailStage"
                              :busy="posting"
                ></moments-form>
                <div v-else-if="isPostedStage">
                    <p>{{$t('support.wizard.label_posted_stage')}}</p>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import Vue from 'vue';
    import {Component} from 'vue-property-decorator';
    import WizardTitleSelect from '../components/support/WizardTitleSelect';
    import WizardDetailSelect from '../components/support/WizardDetailSelect';
    import AppointmentForm from '../components/forms/AppointmentForm';
    import {
        RESET_WIZARD, SUBMIT_SUPPORT_ISSUE,
        GET_APPOINTMENT, SET_APPOINTMENT,
    } from '../store/modules/support_wizard';
    import {FETCH_ACCOUNT_DETAILS, GET_FIELD} from '../store/modules/account_details';
    import WizardStateTracker from '../components/support/WizardStateTracker';
    import {STAGE_TITLE, STAGE_DETAIL, STAGE_APPOINTMENT, STAGE_POSTED} from '../components/support/stages';
    import MomentsForm from '../components/forms/MomentsForm';
    import {CLEAR_MOMENTS, GET_MOMENTS} from '../store/modules/moments';

    @Component({
        components: {MomentsForm, WizardStateTracker, AppointmentForm, WizardDetailSelect, WizardTitleSelect}
    })
    export default class Support extends Vue {
        stage = STAGE_TITLE; //0, 1, 2, 3
        appointment = null;
        posting = false;

        get isTitleStage() {
            return this.stage === STAGE_TITLE;
        }

        get isDetailStage() {
            return this.stage === STAGE_DETAIL;
        }

        get isAppointmentStage() {
            return this.stage === STAGE_APPOINTMENT;
        }

        get isPostedStage() {
            return this.stage === STAGE_POSTED;
        }

        created() {
            this.$store.commit(RESET_WIZARD);
            this.appointment = this.$store.getters[GET_APPOINTMENT];
            this.setAddress();
        }

        async setAddress(){
            if (this.getFieldValue('address') === 'address'){
                await this.$store.dispatch(FETCH_ACCOUNT_DETAILS);
            }
            this.appointment.address.street = this.getFieldValue('address');
            this.appointment.address.number = this.getFieldValue('address_number');
            this.appointment.address.postalCode = this.getFieldValue('postal_code');
            this.appointment.address.city = this.getFieldValue('city_name');
            this.appointment.address.country = this.getFieldValue('country_name');
        }

        getFieldValue(field) {
            return this.$store.getters[GET_FIELD](field);
        }

        gotoTitleStage() {
            this.stage = STAGE_TITLE;
        }

        gotoDetailStage() {
            this.stage = STAGE_DETAIL;
        }

        gotoAppointmentStage() {
            this.stage = STAGE_APPOINTMENT;
        }

        gotoPostedStage() {
            this.stage = STAGE_POSTED;
        }

        submitTicket(comment) {
            this.posting = true;
            let appointment = {
                moments:  this.$store.getters[GET_MOMENTS],
                comment: comment,
                address: this.appointment.address,
                using_client_dashboard: true,
            };
            this.$store.commit(SET_APPOINTMENT, appointment);
            this.$store.dispatch(SUBMIT_SUPPORT_ISSUE)
                .then(() => {
                    // Request succesfull, goto success phase
                    this.$notify.success(this.$t('support.wizard.notify_success'));
                    this.gotoPostedStage();
                    window.scrollTo(0,0);
                }, error => {
                    // Request failed, stay on page
                    this.$notify.error(this.$t('support.wizard.notify_failure'));
                })
                .finally(() => {
                    this.posting = false;
                });
        }
    }
</script>



// WEBPACK FOOTER //
// src/pages/Support.vue